import { verifyMedicaidRequest } from './requests';

export const verifyMedicaidSaga = async ({ action }) => {
  return verifyMedicaidRequest(action.payload);
};
